import mapKeys from "lodash/mapKeys";
import omit from "lodash/omit";
import {
  GET_GROUP_DATA,
  ADD_GROUP,
  REMOVE_GROUP,
  LOG_OUT,
  EDIT_GROUP,
  // REMOVE_DASHBOARD
} from "src/actions/type";

const groupReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_GROUP_DATA:
      return { ...mapKeys(action.payload, "_id") };
    case ADD_GROUP:
      return { ...state, [action.payload._id]: action.payload };
    case EDIT_GROUP:
      return { ...state, [action.payload._id]: action.payload };
    case REMOVE_GROUP:
      return omit(state, action.payload);
    case LOG_OUT:
      return {};
    // case REMOVE_DASHBOARD:
    //   return omit(state, action.payload);
    default:
      return state;
  }
};

export default groupReducer;
